import ProjectData from '@/data/ProjectData.ts'

export default [


      new ProjectData(
        "prensa-grupo",
        "Web Development — Prensa Grupo",
        "img/projects/Energiminas.png",
        `
    <div class="paragraph">
      I work as a web developer supporting <strong>Prensa Grupo</strong>, a Peruvian media group focused on industry news platforms in sectors such as energy, mining, and sustainable transport.
    </div>

    <div class="paragraph">
      I contribute to the development, maintenance, and optimization of multiple high-traffic WordPress-based platforms:
      <ul>
        <li><a href="https://energiminas.com/" target="_blank">Energiminas</a></li>
        <li><a href="https://transportesostenible.com.pe/" target="_blank">Transporte Sostenible</a></li>
        <li><a href="https://peruenergia.com.pe/" target="_blank">Perú Energía</a></li>
        <li><a href="https://prensagrupo.com/" target="_blank">Prensa Grupo</a></li>
      </ul>
    </div>

    <div class="paragraph">
      My responsibilities include:
      <ul>
        <li>Custom development and layout implementation using <strong>WordPress + Elementor</strong>.</li>
        <li>Performance optimization and server-side troubleshooting on <strong>AWS EC2 environments</strong>.</li>
        <li>Debugging production issues, managing assets, and improving content workflows.</li>
        <li>Supporting analytics integration and tracking (e.g., banners, campaigns).</li>
      </ul>
    </div>
    `,
        ['WordPress', 'Elementor', 'AWS'],
        "#1f3a5f",
        false,
        true
    ),

    new ProjectData(
        "eduqy",
        "Eduqy",
        "img/projects/project-eduqy.PNG",
        `
    <div class="paragraph">
      <strong>Eduqy</strong> is an online learning platform designed for educational institutions, connecting students, teachers, and management through a unified system focused on engagement and accessibility.
    </div>

    <div class="paragraph">
      As a <strong>co-founder and full-stack developer</strong>, I contributed across both product and technical areas:
      <ul>
        <li>Participated in product design and feature definition alongside UI/UX designers.</li>
        <li>Led development prioritization and coordinated implementation across the team.</li>
        <li>Developed full-stack features using <strong>Nuxt.js</strong>, <strong>Laravel</strong>, and <strong>AWS</strong>.</li>
        <li>Implemented the public <a href="https://www.eduqy.net/" target="_blank">landing page</a> using Vue.js.</li>
      </ul>
    </div>

    <div class="paragraph">
      The platform includes institution management, content creation, evaluation systems, and reporting tools, and is currently in a growth and expansion phase.
    </div>

    <div class="paragraph center">
      <img class="pc-screenshot" src="img/projects/project-eduqy1.PNG" alt="Eduqy Screenshot" />
      <img class="pc-screenshot" src="img/projects/project-eduqy2.PNG" alt="Eduqy Screenshot" />
    </div>
    `,
        ['Fullstack', 'Vue', 'Laravel', 'AWS', 'Startup'],
        "#132449",
        false,
        false
    ),

    new ProjectData(
        "novatronic",
        "Transactional & Banking Systems (Novatronic)",
        "img/projects/project-switch.webp",
        `
    <div class="paragraph">
      At <a href="https://www.novatronic.com/en/home/" target="_blank">Novatronic</a>, I worked on high-performance transactional systems used in financial environments, focusing on backend and systems-level development.
    </div>

    <div class="paragraph">
      My work involved:
      <ul>
        <li>Developing and maintaining features for an <strong>EFT Switch system</strong> and related applications.</li>
        <li>Advanced programming in <strong>C</strong>, including shared memory, multithreading, semaphores, and plugin-based architectures.</li>
        <li>Building internal tools and libraries using <strong>C++</strong> and <strong>C# .NET</strong> to support team productivity.</li>
        <li>Working across <strong>Linux/Unix environments</strong> with cross-platform builds.</li>
        <li>Integrating with <strong>Oracle</strong> and <strong>PostgreSQL</strong> databases.</li>
      </ul>
    </div>
    `,
        ['C', 'C++', 'Systems Programming', 'Multithreading', 'SQL'],
        "#4b1707",
        false,
        true
    ),



    new ProjectData(
        "teaching-assistant",
        "University Teaching Assistant",
        "img/projects/PUCP_Img.jpg",
        `
    <div class="paragraph">
      Teaching Assistant for the Pontificia Universidad Católica del Perú (PUCP) course <strong>Programming Fundamentals</strong>.
    </div>

    <div class="paragraph">
      I guided first-year students through core programming concepts using the <strong>C language</strong>, including:
      <ul>
        <li>Control flow (conditionals and loops)</li>
        <li>Functions and modular design</li>
        <li>Logical problem-solving and algorithmic thinking</li>
      </ul>
    </div>

    <div class="paragraph">
      This role strengthened my ability to explain technical concepts clearly and mentor early-stage developers.
    </div>

    <div class="paragraph center">
      <img class="pc-screenshot" src="img/projects/PUCP_2.jpg" alt="PUCP aula" />
    </div>
    `,
        ['C', 'Teaching', 'Mentorship'],
        "#11585e",
        false,
        false
    ),
];